/**
 * Mise en forme des nombres. L'espace insécable étroite de `fr-FR` est remplacée
 * par une espace insécable ordinaire : même rendu que la maquette, mais un
 * montant ne se coupe plus en fin de ligne sur un petit écran — « 1 129 000 F »
 * s'affichait parfois « 1 129 » puis « 000 F » (relecture du 06/09/2026).
 */
export function fmt(n: number): string {
  return n.toLocaleString("fr-FR").replace(/[\u202F\u00A0]/g, "\u00A0");
}

/** Date du jour au format français, pour l'attestation et le téléchargement. */
export function dateFr(date = new Date()): string {
  return date.toLocaleDateString("fr-FR");
}

/** Libellé affiché pour un niveau de tâche. */
export function libelleNiveau(niveau: string): string {
  if (niveau === "high") return "Automatisable";
  if (niveau === "mid") return "Partiel";
  return "Résiste";
}

/** Classe de l'étiquette de donnée correspondante. */
export function chipClass(niveau: string): string {
  if (niveau === "high") return "chip c-high";
  if (niveau === "mid") return "chip c-mid";
  return "chip c-low";
}
